export * from '@primeuix/themes/aura/splitbutton';
export { default } from '@primeuix/themes/aura/splitbutton';
